export const TARGET_DATE = new Date('2025-06-15T00:00');

export const BOOK_A_DEMO_LINK = 'https://calendar.app.google/uLzZnzJEhgucpFTS8';

export const BOOK_A_SENSORS_DEMO_LINK = 'https://calendar.app.google/uLzZnzJEhgucpFTS8';

export const BOOK_A_RESEARCH_CALL_LINK = 'https://calendar.app.google/uLzZnzJEhgucpFTS8';
